import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss']
})
export class TermsModalComponent {
  @Input() visible: boolean = false;
  @Input() termsContent: any;
  @Input() title: string = '';
  @Output() closeModal = new EventEmitter<void>();
  
  onHide(): void {
    this.closeModal.emit();
  }
}